import { Pipe, PipeTransform } from '@angular/core'
import { Breadcrumb } from '../breadcrumb'

@Pipe({
  name: 'isExternalHome',
  standalone: false,
})
export class IsExternalHomePipe implements PipeTransform {
  transform(breadcrumb: Breadcrumb): boolean {
    return breadcrumb.link.url === '/'
  }
}
